import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import axios from "axios";

export default function AllOrders({ userData }) {
  const baseURL = "https://ecommerce.routemisr.com"; // or 'https://route-ecommerce-app.vercel.app'

  const [loading, setloading] = useState(true);
  const [userOrders, setuserOrders] = useState(null);

  // Get User Orders
  async function getOrders() {
    try {
      let { data } = await axios.get(
        `${baseURL}/api/v1/orders/user/${userData.id}`
      );
      setuserOrders(data);
      console.log(data);
      setloading(false);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getOrders();
  }, [userData]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Your Orders</title>
      </Helmet>

      {/* Check if no orders display no orders img else display orders and handle displaying loading screen till fetching Data */}
      {loading ? (
        <LoadingScreen />
      ) : userOrders?.length > 0 ? (
        <>
          <h2 className="p-3">All Orders</h2>

          <section className="accordion" id="accordionExample">
            {userOrders.reverse().map((order, indx) => (
              <div className="accordion-item" key={indx}>
                <h2 className="accordion-header">
                  <button
                    className={
                      indx === 0
                        ? "accordion-button"
                        : "accordion-button collapsed"
                    }
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${indx}`}
                    aria-expanded={indx === 0 ? "true" : "false"}
                    aria-controls={`collapse${indx}`}
                  >
                    <div className="w-100">
                      <div className="d-flex justify-content-between align-items-center">
                        {/* display Total order price */}
                        <h4>
                          <span className="text-main fw-semibold">
                            Total Order Price
                          </span>
                          <span className="ms-3">{order.totalOrderPrice} </span>
                          <span>EGP</span>
                        </h4>

                        {/* Display Order status (Payment & Delivery) */}
                        <div className="ms-auto">
                          {order.isPaid !== false ? (
                            <span
                              title="Payment Status"
                              style={{
                                "--fa-animation-duration": "2s",
                                "--fa-fade-opacity": 0.6,
                              }}
                              className="d-inline-block p-2 bg-success text-white rounded-2 fa-fade moderate"
                            >
                              Paid
                            </span>
                          ) : (
                            <span
                              title="Payment Status"
                              style={{
                                "--fa-animation-duration": "2s",
                                "--fa-fade-opacity": 0.6,
                              }}
                              className="d-inline-block p-2 bg-danger text-white rounded-2 fa-fade moderate"
                            >
                              Not Paid yet
                            </span>
                          )}
                          {order.isDelivered !== false ? (
                            <span
                              title="Delivery Status"
                              style={{
                                "--fa-animation-duration": "2s",
                                "--fa-fade-opacity": 0.6,
                              }}
                              className="d-inline-block p-2 bg-success text-white rounded-2 fa-fade ms-2 moderate"
                            >
                              Delivered
                            </span>
                          ) : (
                            <span
                              title="Delivery Status"
                              style={{
                                "--fa-animation-duration": "2s",
                                "--fa-fade-opacity": 0.6,
                              }}
                              className="d-inline-block p-2 bg-danger text-white rounded-2 fa-fade ms-2 moderate"
                            >
                              In Progress
                            </span>
                          )}
                        </div>
                      </div>
                      <hr />

                      {/* display Total Order Items */}
                      <div className=" d-flex justify-content-around text-center">
                        <div className="me-3">
                          <p className="text-main fw-semibold">Cart Items</p>
                          <span>{order.cartItems.length}</span>
                        </div>

                        {/* display Order Tax price */}
                        <div className="me-3">
                          <p className="text-main fw-semibold">Tax Price</p>
                          <span>{order.taxPrice} </span>
                          <span>EGP</span>
                        </div>

                        {/* display Shipping price */}
                        <div className="me-3">
                          <p className="text-main fw-semibold">
                            Shipping Price
                          </p>
                          <span>{order.shippingPrice} </span>
                          <span>EGP</span>
                        </div>

                        {/* display Payment Method */}
                        <div className="me-3">
                          <p className="text-main fw-semibold">
                            Payment Method
                          </p>
                          <span>{order.paymentMethodType}</span>
                        </div>

                        {/* display Order time */}
                        <div className="me-3">
                          <p className="text-main fw-semibold">Order At</p>
                          <span>
                            {new Date(order.createdAt).toLocaleString(
                              "default",
                              { day: "numeric", month: "long", year: "numeric" }
                            )}
                          </span>
                          <br />
                          <span className="font-sm d-inline-block mt-1">
                            {new Date(order.createdAt).toLocaleString(
                              "default",
                              { hour: "2-digit", minute: "2-digit" }
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </button>
                </h2>

                <div
                  id={`collapse${indx}`}
                  className={
                    indx === 0
                      ? "accordion-collapse collapse show"
                      : "accordion-collapse collapse"
                  }
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <div className="row row-cols-1 orderItems">
                      {order.cartItems.map((item, indx) => (
                        <div className="col p-2 " key={indx}>
                          <div className="item d-flex align-items-center pb-2">
                            {/* display order Img Cover  */}

                            <div className="card bg-light h-100">
                              <Link to={`/productdetails/${item.product.id}`}>
                                <img
                                  src={item.product.imageCover}
                                  className="card-img-top w-100"
                                  alt={item.title}
                                  height={120}
                                />
                              </Link>
                            </div>

                            {/* display product Details */}

                            <div className="card-body mx-3">
                              {/* display product count */}

                              <p className="card-text m-0">
                                <span className="text-main fw-bold">
                                  Count:{" "}
                                </span>
                                <span>{item.count}</span>
                              </p>

                              {/* display product price */}

                              <p className="card-text m-0">
                                <span className="text-main fw-bold">
                                  Price Per Item:{" "}
                                </span>
                                <span>{item.price} </span>
                                <span>EGP</span>
                              </p>

                              <p className="card-text m-0">
                                <span className="text-main fw-bold">
                                  Total Price:{" "}
                                </span>
                                <span>{item.price * item.count} </span>
                                <span>EGP</span>
                              </p>

                              {/* display product title */}

                              <p className="card-text m-0">
                                <span className="text-main fw-bold">
                                  Title:{" "}
                                </span>
                                <span>
                                  {item.product.title
                                    .split(" ")
                                    .slice(0, 2)
                                    .join(" ")}
                                </span>
                              </p>

                              {/* Link to products with same brand */}

                              <p className="card-text m-0">
                                <span className="text-main fw-bold">
                                  Brand:{" "}
                                </span>

                                <Link
                                  className="hoveringClick"
                                  to={`/branddetails/${item.product.brand._id}`}
                                >
                                  <span>{item.product.brand.name}</span>
                                </Link>
                              </p>

                              {/* Link to products with same category */}

                              <p className="card-text m-0">
                                <span className="text-main fw-bold">
                                  category:{" "}
                                </span>

                                <Link
                                  className="hoveringClick"
                                  to={`/categorydetails/${item.product.category._id}`}
                                >
                                  <span>{item.product.category.name}</span>
                                </Link>
                              </p>
                            </div>
                          </div>
                          {order?.cartItems.lenght - 1 !== indx ? <hr /> : null}
                        </div>
                      ))}

                      {/* display Shipping Address: */}

                      <div className="d-flex justify-content-between align-content-center mb-2">
                        <div>
                          {" "}
                          <span className="h5 text-main fw-bold">
                            Shipping Address:
                          </span>{" "}
                          <span>{order?.shippingAddress?.details},</span>{" "}
                          {order?.shippingAddress?.city}
                        </div>
                        <div>
                          {" "}
                          <span className="h5 text-main fw-bold">
                            Phone Number:
                          </span>{" "}
                          <span>{order?.shippingAddress?.phone}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </section>
        </>
      ) : (
        <div className="text-center py-1">
          <img
            src={require("../../assets/images/m2-missing-orders-product-image-380x410.png")}
            alt="empty-cart"
          />
          <div>
            <h2 className="h4">
              {" "}
              <Link
                className="hoveringClick fw-bold fa-fade text-main"
                style={{
                  "--fa-animation-duration": "2s",
                  "--fa-fade-opacity": 0.6,
                }}
                to="/"
              >
                Shopping Now
              </Link>
            </h2>
          </div>
        </div>
      )}
    </>
  );
}
